import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function OfferSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section id="oferta" className="bg-navy-dark py-16 md:py-24 relative overflow-hidden" data-id="element-81">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-light via-navy-dark to-navy-dark pointer-events-none" data-id="element-82"></div>

      <div ref={elementRef} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-83">
        <div className="space-y-6 mb-12" data-id="element-84">
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto" data-id="element-85">
            Normalmente, una asesoría para aprender estos hacks costaría más de{' '}
            <span className="line-through text-red-400 font-bold" data-id="element-86">
              $150 la hora
            </span>
            .
          </p>
          <p className="text-xl md:text-2xl text-white font-medium max-w-3xl mx-auto" data-id="element-87">
            Pero mi misión es que nuestra comunidad deje de regalar su esfuerzo
            al gobierno por falta de información.
          </p>
        </div>

        <div className="bg-gradient-to-b from-navy-light to-navy-dark p-8 md:p-12 rounded-3xl border-2 border-gold-primary shadow-[0_0_50px_rgba(212,175,55,0.15)] max-w-2xl mx-auto" data-id="element-88">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-89">
            Obtén la guía completa hoy por solo:
          </h3>

          <div className="flex justify-center items-baseline gap-2 mb-4" data-id="element-90">
            <span className="text-6xl md:text-8xl font-black text-gold-primary tracking-tighter drop-shadow-lg" data-id="element-91">
              $6.39
            </span>
          </div>

          <p className="text-lg text-gray-400 mb-10 italic" data-id="element-92">
            (Menos de lo que cuesta un café en Starbucks)
          </p>

          <CTAButton className="w-full md:w-auto text-xl py-6 px-10" data-id="element-93" />

          <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-400" data-id="element-94">
            <div className="flex items-center gap-2" data-id="element-95">
              <LockIcon className="w-5 h-5 text-green-400" data-id="element-96" />
              <span data-id="element-97">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-98">
              <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-99" />
              <span data-id="element-100">Acceso Inmediato 24/7</span>
            </div>
          </div>

          <p className="mt-6 text-sm text-gray-500" data-id="element-101">
            Tu pago es seguro y recibirás acceso inmediato al PDF incluso si son
            las 3 AM.
          </p>
        </div>
      </div>
    </section>;
}